module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('claim-status')], 1), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "search_individual_claim"
    }
  }, [_c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("\n                    Load Claim\n                ")])])], 1), _vm._v(" "), _c('individual-search-modal')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c51cf96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/form/IndividualSearch.vue
// module id = 1568
// module chunks = 0